<!-- 领券组件UI层 -->
<template>
  <div class="panelContainer">
    <div class="main">
      <div class="head">
        <img class="avatar" :src="defaultAvatarImage" alt="user" />
        <div class="text" :style="avatarTextStyle">{{ headerText }}</div>
      </div>
      <div class="note" :style="valueBlockStyle">{{ note }}</div>
      <div
        v-if="showValueBlock"
        @click="handleClickCouponDetail"
        class="valueBlock"
        :style="valueBlockStyle"
      >
        <div class="unit">&yen;</div>
        <div class="amount">{{ amount | centToYuan }}</div>
        <div class="detailBtn icon-arrow" :style="valueArrowColor"></div>
      </div>
      <div class="countdown" :style="countdownColorStyle">
        <slot name="countdown"></slot>
      </div>
    </div>
    <div class="primaryBtn" v-if="showPrimaryBtn">
      <img :src="mainButtonImage" alt="button" />
      <div class="btnText" :style="primaryBtnStyle">
        <slot name="primaryBtn"></slot>
      </div>
      <div class="badge" v-if="showPrimaryBtnBadge" :style="badgeStyle">
        {{ primaryBtnBadgeText }}
      </div>
    </div>
    <div class="inviteStatus">
      <slot name="inviteProgress"></slot>
    </div>
    <div
      v-if="hasRecordsBtn"
      @click="handleClickRecordsBtn"
      class="recordsBtn"
      :style="recordsBtnStyle"
    ></div>
  </div>
</template>

<script>
import { centToYuan } from '@/components/templates/helper';

export default {
  props: {
    // 头像下面的文字
    headerText: {
      type: String,
      require: true
    },
    // 是否显示活动记录按钮
    hasRecordsBtn: {
      type: Boolean,
      default: false
    },
    // 金额上面的提示
    note: {
      type: String,
      require: true
    },
    // 是否显示金额
    showValueBlock: {
      type: Boolean,
      default: true
    },
    // 是否显示主按钮
    showPrimaryBtn: {
      type: Boolean,
      default: true
    },
    // 是否显示主按钮悬浮标签
    showPrimaryBtnBadge: {
      type: Boolean,
      default: false
    },
    // 主按钮悬浮标签文字
    primaryBtnBadgeText: {
      type: String
    },
    // 主按钮文字
    primaryBtnText: {
      type: String
    },
    // 金额
    amount: {
      type: Number
    },
    // 默认头像
    defaultAvatarImage: String,
    // 头像文案颜色
    avatarFontColor: {
      type: String
    },
    // 头像文案背景图
    avatarFontBackgroundImage: String,
    // 金额色
    prizeFontColor: String,
    // 金额详情按钮色
    prizeArrowFontColor: String,
    // 倒计时文案颜色
    timerFontColor: String,
    // 主按钮图片
    mainButtonImage: String,
    // 主按钮文案颜色
    mainButtonFontColor: String,
    // 主按钮利益点按钮
    mainButtonPoptipBackgroundImage: String,
    // 空态头像
    emptyAvatarImage: String,
    // 活动记录按钮
    activityRecordImage: String
  },
  computed: {
    avatarTextStyle() {
      return {
        background: `center / cover url("${this.avatarFontBackgroundImage}") no-repeat`,
        color: this.avatarFontColor
      };
    },
    valueBlockStyle() {
      return {
        color: this.prizeFontColor
      };
    },
    valueArrowColor() {
      return {
        color: this.prizeArrowFontColor
      };
    },
    countdownColorStyle() {
      return {
        color: this.timerFontColor
      };
    },
    primaryBtnStyle() {
      return {
        color: this.mainButtonFontColor
      };
    },
    badgeStyle() {
      return {
        background: `center / cover url("${this.mainButtonPoptipBackgroundImage}") no-repeat`
      };
    },
    recordsBtnStyle() {
      return {
        background: `center / cover url("${this.activityRecordImage}") no-repeat`
      };
    }
  },
  filters: {
    centToYuan
  },
  methods: {
    handleClickCouponDetail() {
      this.$emit('showCouponDetail');
    },
    handleClickRecordsBtn() {
      this.$emit('clickRecordBtn');
    }
  }
};
</script>

<style lang="less" scoped>
.panelContainer {
  text-align: center;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 280px;

  .main {
    height: 544px;

    .head {
      position: absolute;
      top: 5px;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      flex-direction: column;
      align-items: center;
      .avatar {
        width: 120px;
        height: 120px;
        background: #fff;
        border: 4px solid #ffffff;
        border-radius: 50%;
      }
      .text {
        position: relative;
        top: -15px;
        width: 170px;
        border-radius: 25px;
        padding: 5px 10px;
        font-size: 26px;
      }
    }

    .note {
      position: absolute;
      top: 196px;
      left: 50%;
      transform: translateX(-50%);
      width: 460px;
      font-size: 32px;
      line-height: 1.5;
      font-weight: bold;
      color: inherit;
    }

    .valueBlock {
      position: absolute;
      top: 252px;
      left: 50%;
      transform: translateX(-50%);
      font-family: 'Alibaba Zhixing';
      line-height: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      color: inherit;

      .unit {
        align-self: flex-end;
        margin-bottom: 7px;
        font-size: 60px;
      }
      .amount {
        font-size: 120px;
      }
      .detailBtn {
        margin-left: 20px;
        margin-top: 20px;
        width: 20px;
        height: 35px;
      }
    }

    .countdown {
      position: absolute;
      top: 450px;
      left: 50%;
      transform: translateX(-50%);
      font-size: 28px;
      color: #ffffff;
    }
  }

  .primaryBtn {
    position: relative;
    width: 100%;
    margin: 77px auto 0;
    font-size: 40px;
    z-index: 0;
    line-height: 1;

    > img {
      width: 100%;
    }

    .btnText {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1;
      width: 100%;
      height: 100%;
      background-color: transparent;
    }

    .badge {
      position: absolute;
      top: -30px;
      left: 460px;
      width: 200px;
      height: 44px;
      font-size: 26px;
      color: #ff264b;
      .fcc;
      line-height: normal;
    }
  }

  .inviteStatus {
    margin-top: 52px;
    max-width: 750px;
  }

  .recordsBtn {
    margin-top: 60px;
    width: 160px;
    height: 40px;
  }
}
</style>
